var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoOutlook = function SvgLogoOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.24 0h69.6v238.179h361.24c24.084-1.204 56.234 5.78 55.753 36.124 4.455 150.638 0 301.637 2.047 452.395 0 26.612 0 68.636-36.125 68.997-127.638 4.576-255.638 0-383.277 1.806v226.017H532.23C355.34 991.007 177.61 960.662 0 928.753V95.488C178.453 63.458 356.907 32.512 535.24 0z",
    fill: "#0071C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M604.96 273.821h387.25a58.642 58.642 0 0 1-19.747 40.7Q856.865 425.181 741.75 535.842c-46.24-42.145-91.515-86.939-136.79-130.408zm-355.583 43.59c65.626-25.287 142.33 10.235 170.145 75.138 38.05 89.107 32.512 211.447-42.867 279-69.48 60.206-185.92 26.25-217.468-60.208-41.663-99.702-21.433-253.11 90.19-293.93z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M778.356 546.438c70.08-68.033 140.643-135.586 210.965-203.138v418.8H604.96V450.71c43.469 39.254 82.363 84.29 128.481 120.413 19.146 3.01 32.03-13.727 44.915-24.685z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.696 389.057a63.699 63.699 0 0 1 84.29 31.549 212.892 212.892 0 0 1 7.947 154.37c-10.837 35.402-48.165 64.542-85.253 50.574-45.757-14.69-59.605-70.201-60.207-113.67s9.272-101.148 53.223-122.823z",
    fill: "#0071C5"
  })));
};
export default SvgLogoOutlook;